import { BilledEntity, BilledEntityType, InvoiceLineType } from '@/types/facturation.types'

const MONTH_NAMES = [
  'Janvier',
  'Février',
  'Mars',
  'Avril',
  'Mai',
  'Juin',
  'Juillet',
  'Août',
  'Septembre',
  'Octobre',
  'Novembre',
  'Décembre',
] as const

export function formatCurrency(amount: number): string {
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR',
  }).format(amount)
}

export function formatInvoicePeriod(month: number, year: number): string {
  const monthName = MONTH_NAMES[month - 1]
  if (!monthName) return `${month}/${year}`
  return `${monthName} ${year}`
}

export function formatInvoiceDate(date: string): string {
  return new Date(date).toLocaleDateString('fr-FR', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}

export function getInvoiceLineTypeLabel(lineType: InvoiceLineType): string {
  return lineType === 'new' ? 'Nouvelle licence' : 'Renouvellement'
}

export function getInvoiceLineTypeBadgeClasses(lineType: InvoiceLineType): string {
  return lineType === 'new'
    ? 'bg-emerald-50 text-emerald-800'
    : 'bg-sky-50 text-sky-800'
}

export function getBilledEntityLabel(entity: BilledEntity): string {
  if (entity.companyName) return entity.companyName
  const name = `${entity.firstname ?? ''} ${entity.lastname ?? ''}`.trim()
  return name || entity._id
}

export function getBilledEntityTypeLabel(type: BilledEntityType): string {
  switch (type) {
    case 'WHOLESALER':
      return 'Grossiste'
    case 'RESELLER':
      return 'Revendeur direct'
    case 'CLIENT_DIRECT':
      return 'Client direct'
    default:
      return type
  }
}

export function getBilledEntityTypeBadgeClasses(type: BilledEntityType): string {
  switch (type) {
    case 'WHOLESALER':
      return 'bg-violet-50 text-violet-800'
    case 'RESELLER':
      return 'bg-sky-50 text-sky-800'
    case 'CLIENT_DIRECT':
      return 'bg-emerald-50 text-emerald-800'
    default:
      return 'bg-gray-100 text-gray-700'
  }
}
